var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-widget"},[_c('router-link',{staticClass:"reset-filters",attrs:{"to":{name: 'shop'}}},[_vm._v(_vm._s(_vm.$t("shop.sidebar.reset_filters")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }